import React from "react";
import { Container } from "react-bootstrap";
import Particle from "../Particle";

function Scenes() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>

        <p style={{ color: "white" }}>
        <h3 style={{ fontSize: "2.5em" }}>
            <span className="purple"> Scene </span> Ideas
        </h3>

        <h4> Casting.</h4>

        <h4> Sex Tape. </h4>

        <h4> Lingerie Model. </h4>

        <h4> Hotwife Breeding. </h4>

        <h4> Professor and Student. </h4>

        <h4> Tantric Massage. </h4>

        <h4> Internet Stranger. </h4>

        <h4> Masturbation Instrusion. </h4>

        <h4> Neighbor. </h4>

        <h4> Step Family. </h4>

        <h4> Cheating. </h4>

        </p>

      </Container>
    </Container>
  );
}

export default Scenes;
